<template>
    <div>
        <div class="mt-3">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header font-weight-bold">
                            Inscripción de Jurado
                        </div>
                        <div class="card-body">
                            <ValidationObserver v-slot="{ invalid }">
                                <form @submit.prevent="handleSaveSworn">
                                    <ValidationProvider
                                        rules="required|alpha_spaces"
                                        name="nombre completo"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group">
                                            <label for="inputAddress"
                                                >Nombre completo</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="inputAddress"
                                                placeholder="Ej: Juan Sebastían Rozo Gil"
                                                v-model="form.name"
                                            />
                                            <span class="text-danger mt-1">{{
                                                errors[0]
                                            }}</span>
                                        </div>
                                    </ValidationProvider>

                                    <div class="row row-cols-1 row-cols-md-3">
                                        <ValidationProvider
                                            rules="required|email"
                                            name="correo"
                                            v-slot="{ errors }"
                                        >
                                            <div class="form-group col">
                                                <label for="email"
                                                    >Correo electrónico</label
                                                >
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    id="email"
                                                    v-model="form.email"
                                                />
                                                <span
                                                    class="text-danger mt-1"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            rules="required|min:8"
                                            name="contraseña"
                                            v-slot="{ errors }"
                                            vid="password"
                                        >
                                            <div class="form-group col">
                                                <label for="password"
                                                    >Contraseña
                                                    <a
                                                        href="#"
                                                        @click="
                                                            showPassword(
                                                                'password'
                                                            )
                                                        "
                                                        >(Ver / Ocultar)</a
                                                    ></label
                                                >
                                                <input
                                                    type="password"
                                                    class="form-control"
                                                    id="password"
                                                    v-model="form.password"
                                                    name="password"
                                                />
                                                <span
                                                    class="text-danger mt-1"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            rules="required|min:8|confirmed:password"
                                            name="confirmar contraseña"
                                            v-slot="{ errors }"
                                        >
                                            <div class="form-group col">
                                                <label
                                                    for="password_confirmation"
                                                    >Confirmar contraseña
                                                    <a
                                                        href="#"
                                                        @click="
                                                            showPassword(
                                                                'password_confirmation'
                                                            )
                                                        "
                                                        >(Ver / Ocultar)</a
                                                    ></label
                                                >
                                                <input
                                                    type="password"
                                                    class="form-control"
                                                    id="password_confirmation"
                                                    name="password_confirmation"
                                                    v-model="
                                                        form.password_confirmation
                                                    "
                                                />
                                                <span
                                                    class="text-danger mt-1"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </ValidationProvider>
                                    </div>

                                    <ValidationProvider
                                        rules="required"
                                        name="tipo de jurado"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-row">
                                            <div class="card col-md-12 p-0">
                                                <div
                                                    class="card-header font-weight-bold"
                                                >
                                                    Tipo de jurado
                                                </div>
                                                <div
                                                    class="card-body card-type-judge"
                                                >
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="internal"
                                                            value="internal"
                                                            v-model="form.types"
                                                            @click="
                                                                controlSwornType()
                                                            "
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="internal"
                                                            >Interno</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="external"
                                                            value="external"
                                                            v-model="form.types"
                                                            @click="
                                                                controlSwornType()
                                                            "
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="external"
                                                            >Externo</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="optional"
                                                            value="optional"
                                                            v-model="form.types"
                                                            @click="
                                                                controlSwornTypeOptional()
                                                            "
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="optional"
                                                            >Opcional</label
                                                        >
                                                    </div>
                                                </div>
                                                <span
                                                    class="text-danger mx-4 mb-2"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </div>
                                    </ValidationProvider>

                                    <div class="form-row">
                                        <div class="card col-md-12 p-0">
                                            <div
                                                class="card-header font-weight-bold"
                                            >
                                                Selecciona las categorías a
                                                asignar
                                            </div>
                                            <div class="card-body">
                                                <div
                                                    class="flex"
                                                    v-for="category in categories"
                                                    :key="category.id"
                                                >
                                                    <label class="col-md-6">{{
                                                        category.name
                                                    }}</label>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input category_evolution_item"
                                                            :id="`category_evolution_${category.id}`"
                                                            :data-category-id="
                                                                category.id
                                                            "
                                                            name="evolution"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            :for="`category_evolution_${category.id}`"
                                                            >Evolución</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input category_increase_item"
                                                            :id="`category_increase_${category.id}`"
                                                            :data-category-id="
                                                                category.id
                                                            "
                                                            name="increase"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            :for="`category_increase_${category.id}`"
                                                            >Crecimiento</label
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        @click="changeView(1)"
                                        type="button"
                                        class="btn btn-outline-secondary my-2"
                                    >
                                        Volver
                                    </button>
                                    <button
                                        type="submit"
                                        class="btn btn-primary"
                                        :disabled="invalid"
                                    >
                                        Crear Jurado
                                    </button>
                                </form>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import helpers from "../../mixins/index";

export default {
    name: "SwornCreate",
    mixins: [helpers],
    props: {
        contestId: Number,
    },
    data() {
        return {
            form: {
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                types: [],
                categories: [],
                contest_id: this.contestId,
            },
            categories: [
                {
                    name: "Salud y bienestar",
                    id: "2",
                },
                {
                    name: "Educación de calidad",
                    id: "3",
                },
                { name: "Impacto al medio ambiente", id: "4" },
                {
                    name: "Transparencia, justicia y cero corrupción",
                    id: "6",
                },
                {
                    name: "Ciudades y comunidades sostenibles",
                    id: "5",
                },
                {
                    name: "Inclusión, reducción de desigualdades y pobreza",
                    id: "1",
                },
            ],
        };
    },
    methods: {
        changeView(page) {
            this.$emit("change", page);
        },

        handleSaveSworn(event) {
            const me = this;

            me.loading();

            const inEvolution = document.querySelectorAll(
                ".category_evolution_item"
            );

            const inIncrease = document.querySelectorAll(
                ".category_increase_item"
            );

            this.form.categories = [...inEvolution].map((item, idx) => {
                const id = item.dataset.categoryId;

                return {
                    id: id,
                    name: this.categories.find((item) => item.id === id).name,
                    evolution: item.checked,
                    increase: [...inIncrease][idx].checked,
                };
            });

            axios
                .post(`/api/sworn_`, this.form)
                .then(function (response) {
                    const { success, message } = response.data?.data;
                    if (success) {
                        me.closeLoading();
                        me.showActionSuccess(`${message}`);
                    }
                })
                .catch(function (error) {
                    let content = "";

                    if (error.response.status === 422) {
                        if (
                            typeof error.response?.data?.messages === "string"
                        ) {
                            content = error.response?.data?.messages;
                        } else {
                            const errors = Object.values(
                                error.response?.data?.messages
                            );
                            content = errors
                                .map((item) => `<li>${item}</li>`)
                                .join("");
                        }
                        me.showSwalError(`<ul>${content}</ul>`);
                    } else {
                        me.showSwalError(
                            "No fue posible procesar su solicitud, intente mas tarde."
                        );
                    }
                });
        },

        controlSwornType() {
            const me = this;

            setTimeout(() => {
                if (
                    me.form.types.includes("internal") ||
                    me.form.types.includes("external")
                ) {
                    me.form.types = me.form.types.filter(
                        (el) => el !== "optional"
                    );
                }
            }, 100);
        },

        controlSwornTypeOptional() {
            const me = this;

            setTimeout(() => {
                if (me.form.types.includes("optional")) {
                    me.form.types = me.form.types.filter(
                        (el) => el === "optional"
                    );
                }
            }, 100);
        },
    },
};
</script>
<style lang="scss" scoped>
.card-type-judge {
    padding: 20px 45px;
}

.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
